import {SmartComponent} from "smart-component-js";
import GenericModalComponent from "../utils/GenericModalComponent";

class CouponComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.campaignCode = this.element.dataset.campaignCode;
        this.endpoint = `/api/1.0/loyalty/campaign/${this.campaignCode}/coupon-set/my-coupons`;
        this.wrapperInfo = document.querySelector('.coupons__instruction-wrapper');
        this.init();
    }

    checkCoupon() {
        return youserxp.ajax(this.endpoint, {method: 'GET', auth: true}).then(
            (data) => {
                this.couponList = data.body;
                if (this.couponList.length > 0) {
                    this.wrapperInfo.classList.remove('hidden');
                    this.createCoupon();
                    this.createPrintModal();
                } else {
                    this.createNoResult();
                }
            },
            (err) => {
                // 400 se l'utente non è iscritto alla campagna (l'iscrizione la fa MyCouponsCampaignFilter)
                console.error(err);
                this.createNoResult();
            }
        );
    }

    // stessa struttura del widget couponlist dell'SDK youserxp, così valgono gli stili di _coupons.scss
    createCoupon() {
        const rows = this.couponList.map((coupon) => this.getCouponRow(coupon)).join('');
        // la lista va sopra le istruzioni "Come faccio a utilizzare i miei coupon?"
        this.wrapperInfo.closest('.yxpRow').insertAdjacentHTML('beforebegin', `
            <div class="yxp-lt-couponlist-container">
                <div class="yxp-lt-couponlist-wrapper">
                    <div class="yxp-lt-couponlist-results">${rows}</div>
                </div>
            </div>`);
    }

    // nessun coupon disponibile: messaggio al posto della lista (le istruzioni restano nascoste)
    createNoResult() {
        this.wrapperInfo.closest('.yxpRow').insertAdjacentHTML('beforebegin', `
            <div class="coupons__no-result">
                <img class="coupons__no-result-image" src="/fe-web/img/mydonnad/no-coupon.png" alt="">
                <p class="coupons__no-result-title">Non hai coupon disponibili al momento</p>
                <p class="coupons__no-result-text">Seguici sui nostri canali social oppure partecipa al programma fedeltà DLovers per non perderti i prossimi coupon pensati per te.</p>
            </div>`);
    }

    // ogni elemento è un coupon prenotato: i dati grafici stanno sul suo coupon set e arrivano già in HTML.
    // Si identifica per id perché dopo il riscatto il code dei coupon Valassis diventa il link di download
    getCouponRow(coupon) {
        const couponSet = coupon.couponSet;
        return `
            <div class="yxp-coupon-row" data-coupon-id="${coupon.id}">
                <div class="yxp-coupon-image" style="background-image: url('${couponSet.listImage?.url ?? ''}')">
                    ${couponSet.htmlLabel ?? ''}
                </div>
                <div class="yxp-coupon-info">
                    <h2 class="yxp-coupon-title">${couponSet.label ?? ''}</h2>
                    <div class="yxp-coupon-description">${couponSet.description ?? ''}</div>
                    <div class="yxp-coupon-disclaimer">${couponSet.disclaimer ?? ''}</div>
                    <div class="yxp-coupon-cta-wrapper">${this.getCouponCta(coupon)}</div>
                </div>
            </div>`;
    }

    // un coupon già riscattato (anche instant-redemption) non si genera più da qui: resta solo l'etichetta
    getCouponCta(coupon) {
        return coupon.status === 'REDEEMED'
            ? '<p class="yxp-coupon-print-ended">Coupon Scaricato</p>'
            : '<a href="javascript:void(0)" class="yxp-coupon-print" data-print-button>Genera Coupon</a>';
    }

    // modale "Stampa a colori il tuo coupon": si apre da "Genera Coupon" e chiede di confermare le istruzioni
    createPrintModal() {
        // nel body: un contenitore della pagina farebbe da riferimento al position: fixed e taglierebbe l'overlay
        document.body.insertAdjacentHTML('beforeend', `
            <div class="generic-modal coupon-modal">
                <div class="generic-modal__overlay"></div>
                <div class="generic-modal__card">
                    <div class="generic-modal__close"><a href="javascript:void(0)"></a></div>
                    <div class="generic-modal__title">Stampa a colori il tuo coupon</div>
                    <div class="generic-modal__description">
                        <p>Per utilizzare il coupon, assicurati di stamparlo a colori.<br>
                        Se non hai la possibilità di stamparlo subito, puoi scaricarlo in PDF e stamparlo in seguito.</p>
                        <p>Se hai bisogno di ulteriori informazioni su come utilizzarlo,<br>
                        <a href="${window.GENERIC_TRANSLATIONS?.faqLink ?? ''}">consulta le nostre FAQ</a>.</p>
                    </div>
                    <label class="coupon-modal__check">
                        <input type="checkbox">
                        <span>Ho letto e compreso le istruzioni per l’utilizzo del coupon</span>
                    </label>
                    <div class="coupon-modal__actions">
                        <p class="coupon-modal__hint">Conferma di aver letto le istruzioni per proseguire</p>
                        <p class="coupon-modal__error hidden">Non è stato possibile generare il coupon, riprova più tardi</p>
                        <div class="generic-modal__cta-wrapper">
                            <div class="secondary-button bordered"><a href="javascript:void(0)" data-coupon-cancel>Annulla</a></div>
                            <div class="primary-button"><a href="javascript:void(0)" class="disabled" data-coupon-confirm>Stampa o scarica</a></div>
                        </div>
                    </div>
                </div>
            </div>`);
        this.printModalEl = document.body.querySelector(':scope > .coupon-modal');
        this.printModal = new GenericModalComponent(this.printModalEl);
        this.addPrintModalListeners();
    }

    addPrintModalListeners() {
        const checkbox = this.printModalEl.querySelector('input[type="checkbox"]');
        const confirm = this.printModalEl.querySelector('[data-coupon-confirm]');
        this.printErrorEl = this.printModalEl.querySelector('.coupon-modal__error');
        // "Stampa o scarica" si abilita solo dopo la conferma delle istruzioni
        checkbox.addEventListener('change', () => confirm.classList.toggle('disabled', !checkbox.checked));
        this.printModalEl.querySelector('[data-coupon-cancel]').addEventListener('click', () => this.printModal.closeModal());
        confirm.addEventListener('click', () => {
            if (!confirm.classList.contains('disabled')) this.redeemCoupon(this.selectedCoupon);
        });
        this.element.addEventListener('click', (e) => {
            const print = e.target.closest('.yxp-coupon-print');
            if (!print) return;
            const id = print.closest('.yxp-coupon-row').dataset.couponId;
            this.selectedCoupon = this.couponList.find((item) => String(item.id) === id);
            checkbox.checked = false;
            confirm.classList.add('disabled');
            this.printErrorEl.classList.add('hidden');
            this.printModal.openModal();
        });
    }

    redeemCoupon(coupon) {
        // la scheda va aperta dentro il click: aperta dopo la chiamata asincrona verrebbe bloccata come popup
        const tab = window.open('', '_blank');
        this.printErrorEl.classList.add('hidden');
        this.printModalEl.classList.add('loading');
        youserxp.ajax(this.getRedeemUrl(coupon), {
            method: 'POST',
            auth: true,
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({})
        }).then((data) => {
            Object.assign(coupon, {status: data.body.status, code: data.body.code});
            this.printModalEl.classList.remove('loading');
            this.openDownload(tab, coupon);
            this.updateCouponCta(coupon);
        }).catch((err) => {
            console.error(err);
            this.printModalEl.classList.remove('loading');
            this.showPrintError(tab);
        });
    }

    // il redeem va fatto sulla campagna della landing in cui il coupon è stato prenotato, non su coupon-henkel
    getRedeemUrl(coupon) {
        const campaignCode = coupon.couponSet.campaignCodes.find((code) => code !== this.campaignCode);
        return `/api/1.0/loyalty/campaign/${campaignCode}/coupon/${encodeURIComponent(coupon.code)}/redeem`;
    }

    openDownload(tab, coupon) {
        const url = this.getDownloadUrl(coupon);
        if (!url) {
            this.showPrintError(tab);
            return;
        }
        tab.location.href = url;
        this.printModal.closeModal();
    }

    // dopo il riscatto la card mostra "Coupon Scaricato" senza ricaricare la lista
    updateCouponCta(coupon) {
        this.element.querySelector(`.yxp-coupon-row[data-coupon-id="${coupon.id}"] .yxp-coupon-cta-wrapper`).innerHTML = this.getCouponCta(coupon);
    }

    showPrintError(tab) {
        tab?.close();
        this.printErrorEl.classList.remove('hidden');
    }

    // coupon Valassis (tag landing-coupon): dopo il riscatto il code contiene il link di download.
    // Se la chiamata a Valassis fallisce il coupon risulta riscattato ma il code resta quello originale, non un URL
    getDownloadUrl(coupon) {
        if (!coupon.couponSet.tags?.includes('landing-coupon')) return coupon.couponSet.pdfImage?.url;
        return /^https?:\/\//.test(coupon.code) ? coupon.code : null;
    }

    init() {
        this.checkCoupon();
    }


}

export default CouponComponent;
